import React, { createContext, useContext, useState, useEffect } from 'react';
import { useAuth } from './AuthContext';
import { db } from '../config/firebase';
import { 
  collection, 
  query, 
  where, 
  onSnapshot, 
  doc, 
  setDoc,
  deleteDoc 
} from 'firebase/firestore';

const WatchlistContext = createContext();

export function useWatchlist() {
  return useContext(WatchlistContext);
}

export function WatchlistProvider({ children }) {
  const [watchlist, setWatchlist] = useState([]);
  const { user } = useAuth();

  useEffect(() => {
    if (!user) {
      setWatchlist([]);
      return;
    }

    // Subscribe to watchlist changes
    const watchlistRef = collection(db, 'users', user.uid, 'watchlist');
    const unsubscribe = onSnapshot(watchlistRef, (snapshot) => {
      const watchlistItems = snapshot.docs.map(doc => ({
        id: doc.data().id,
        ...doc.data()
      }));
      setWatchlist(watchlistItems);
    });

    return () => unsubscribe();
  }, [user]);

  const addToWatchlist = async (userId, show) => {
    if (!user) return;
    
    try {
      // Clean the show data to remove undefined values
      const cleanedShow = {
        id: show.id,
        imdb_id: show.imdb_id || null,
        title: show.title || '',
        poster: show.poster || '',
        year: show.year || null,
        total_seasons: show.total_seasons || null,
        streamingSources: show.streamingSources || [],
        plot_overview: show.plot_overview || '',
        backdrop: show.backdrop || '',
        addedAt: new Date()
      };

      // Remove any remaining null values
      Object.keys(cleanedShow).forEach(key => 
        cleanedShow[key] === null && delete cleanedShow[key]
      );

      const watchlistRef = doc(db, 'users', userId, 'watchlist', show.id.toString());
      await setDoc(watchlistRef, cleanedShow);
    } catch (error) {
      console.error('Error adding to watchlist:', error);
      throw error;
    }
  };

  const removeFromWatchlist = async (userId, showId) => {
    if (!user) return;
    
    try {
      const watchlistRef = doc(db, 'users', userId, 'watchlist', showId.toString());
      await deleteDoc(watchlistRef);
    } catch (error) {
      console.error('Error removing from watchlist:', error);
      throw error;
    }
  };

  const value = {
    watchlist,
    setWatchlist,
    addToWatchlist,
    removeFromWatchlist
  };

  return (
    <WatchlistContext.Provider value={value}>
      {children}
    </WatchlistContext.Provider>
  );
} 